interface DepartmentsTabsProps {
  Tabs: string[];
  handleSelectTab: (num: number) => void;
  selectedTab: number;
}
const DepartmentsTabs = ({ Tabs, handleSelectTab, selectedTab }: DepartmentsTabsProps) => (
  <div className="department-panel-tabs flex items-center gap-4 mt-4">
    <div className="flex w-full">
      {Tabs.map((label, index) => (
        <button
          key={index}
          onClick={() => handleSelectTab(index)}
          className={`tabs px-4 text-gray-500 hover:text-gray-700 focus:outline-none w-full ${
            selectedTab === index
              ? 'border-t-3 border-blue-500 border-opacity-70 active-tab'
              : 'border-t-3 border-gray-500 bg-gray-300 border-opacity-70 inactive-tab'
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  </div>
);

export default DepartmentsTabs;
